/** T81 — Clinic settings API client. */
import { apiClient } from "./client";

export type DayKey = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";

export interface DayHours {
  open: string; // "08:00"
  close: string; // "17:30"
}

/** Map of weekday → working hours, or null for nghỉ. */
export type WorkingHours = Partial<Record<DayKey, DayHours | null>>;

export interface ClinicSettings {
  id: string;
  code: string;
  name: string;
  address: string | null;
  phone: string | null;
  email: string | null;
  taxCode: string | null;
  facilityRegistrationNo: string | null;
  /** raw JSON string from the API; parse client-side. */
  workingHoursJson: string | null;
  timezone: string;
}

export interface ClinicSettingsUpdate {
  name: string;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  taxCode?: string | null;
  facilityRegistrationNo?: string | null;
  workingHours?: WorkingHours | null;
}

export const clinicSettingsApi = {
  get(): Promise<ClinicSettings> {
    return apiClient.get<ClinicSettings>("/v1/clinic/settings").then((r) => r.data);
  },
  update(req: ClinicSettingsUpdate): Promise<ClinicSettings> {
    return apiClient.put<ClinicSettings>("/v1/clinic/settings", req).then((r) => r.data);
  },
};

export const clinicSettingsQueryKeys = {
  current: () => ["clinic", "settings"] as const,
};

export function parseWorkingHours(json: string | null): WorkingHours {
  if (!json) return {};
  try {
    return JSON.parse(json) as WorkingHours;
  } catch {
    return {};
  }
}
